import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { ScoringOngoingModal } from "@/components/ScoringOngoingModal/ScoringOngoingModal";

import { ScoreShell } from "../../shell/ScoreShell";
import { SettingsBox } from "../../shell/SettingsBox";

const PLACEHOLDER_ROWS = [
	{ id: "prospects", chips: 3 },
	{ id: "partners", chips: 2 },
	{ id: "investors", chips: 4 },
];

/**
 * Shown while the onboarding still builds the lead scoring (PREC-4055): the
 * settings frame with a blurred placeholder behind the "we are creating your
 * lead scoring" dialog, so the page already looks like what is coming.
 */
export const ScoreLoading: FunctionComponent = () => {
	const { t } = useTranslation();

	return (
		<div className="relative" data-testid="score-loading">
			<div aria-hidden="true" className="pointer-events-none select-none blur-sm">
				<ScoreShell intro={t("leadScoring.loading.intro")} step="company">
					{PLACEHOLDER_ROWS.map(({ id, chips }) => (
						<SettingsBox
							key={id}
							title={<span className="inline-block h-4 w-40 rounded bg-background-light" />}
						>
							<div className="flex flex-wrap gap-2">
								{Array.from({ length: chips }, (_, chip) => (
									<span key={chip} className="h-[30px] w-32 rounded-full bg-background-light" />
								))}
							</div>
						</SettingsBox>
					))}
				</ScoreShell>
			</div>
			<ScoringOngoingModal />
		</div>
	);
};
